import store from '@/store/index';
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'fr-faq-top'
  },
  {
    path: '/fr-ask',
    name: 'fr-faq',
    component: () => import('../views/faq/FRFAQ.vue')
  },
  {
    path: '/fr-ask-category',
    name: 'fr-faq-category',
    component: () => import('../views/faq/FRFAQCategory.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// ログイン後画面、遷移制御
router.beforeEach(async (to, from, next) => {
  // local環境確認用
  if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'local2') {
    console.log('environment' + ' ' + process.env.NODE_ENV);
  }

  store.dispatch('startLoading'); // loading画面の表示
  window.scrollTo({top: 0}); // 読み込み時に画面最上部へ

  if (from.name === to.name) { // 遷移元と、遷移先が同じ画面の場合
    store.dispatch('endLoading'); // loading画面の非表示
  }

  // /での遷移時 fr-faqに遷移 urlを host/#/fr-ask にする
  if (to.name === 'fr-faq-top') {
    next({ name: 'fr-faq'});
  } else {
    next();
  }
});

export default router